import PendoGuide from './PendoGuide';
import Logger from '_acaSrc/utility/Logger';

const PENDO_RESOURCE_CENTER_GUIDE = 'aca-resource-center';

export default class ResourceCenterGuide extends PendoGuide {
    _getGuideName() {
        return this._getGuideNameIfActive(PENDO_RESOURCE_CENTER_GUIDE);
    }

    _hasResourceCenterContent() {
        try {
            return this._pendo && this._pendo.findGuideByName(PENDO_RESOURCE_CENTER_GUIDE)
            && this._pendo.findGuideByName(PENDO_RESOURCE_CENTER_GUIDE).hasResourceCenterContent;
        }
        catch(e) {
            Logger.warn(`Error getting PendoGuide name while checking ResourceCenterContent: ${e}`);
            return false;
        }
    }
}